/*
 *
 * AmlPopup
 *
 * @version 1.0.0
 * @author Minozzi Elia
 * @since 30-Giu-2025
*/

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import AmlPopup from './AmlPopup'
import { nullSafe } from 'Utility/globalMethods'
import { doHidePopup, doShowPopup } from 'Store/actions/popup'
import * as TriggerTimelineActions from 'Store/actions/triggerTimeline'
import { doLogout } from 'Store/actions/login'
import { doCheckOtpAml } from 'Store/actions/sca'

const mapDispatchToProps = dispatch => ({
  ...bindActionCreators(TriggerTimelineActions, dispatch),
  doHidePopup: () => dispatch(doHidePopup()),
  doShowPopup: (type) => dispatch(doShowPopup(type)),
  doLogout: () => dispatch(doLogout()),
  doCheckOtpAml: (payload) => dispatch(doCheckOtpAml(payload))
})

const mapStateToProps = (state) => ({
  userRole: nullSafe(() => state.userProfiling.profiling.user.userRole, ''),
  amlStatus: nullSafe(() => state.userProfiling.amlStatusInfo.status, ''),
  amlUpdating: nullSafe(() => state.userProfiling.amlStatusInfo.survey_updating, false),
  isLoading: nullSafe(() => state.loading.localLoading.get_aml_status, false)
})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(AmlPopup)
